import { render, staticRenderFns } from "./ProductionReturnList.vue?vue&type=template&id=6d84626b&"
import script from "./ProductionReturnList.vue?vue&type=script&lang=js&"
export * from "./ProductionReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports